var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.src)?_c('SocTableItemDescription',{attrs:{"src":_vm.src,"small":_vm.small}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }